import React, { useEffect, useRef } from 'react';
import { ISelectOption } from '@creditflowresearch/uilib/Select';
import { useRouter } from '@framework/router';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';
import { usePageFiltersStateContext } from '@/creditflowresearch/application/PageFiltersState/PageFiltersStateContext';
import TTMSelect from '@/creditflowresearch/ui/common/components/atoms/TTMSelect';

const LeagueTableTTMSelect = () => {
  const { query: { products, regions } } = useRouter();
  const didMount = useRef(false);
  const {
    state,
    getLeagueTablePeriods,
    resetLeagueTablePeriod,
    setLeagueTablePeriod,
  } = useLeagueTableFiltersContext();

  const selectedPeriod = state.periods.leagueTable.selected;
  const periodsCollection = state.periods.leagueTable.collection;

  const {
    state: {
      productIds: includedProductIds,
      regionIds: includedRegionIds,
    },
  } = usePageFiltersStateContext();

  const onChange = (option: ISelectOption): void => {
    if (option) {
      setLeagueTablePeriod(option);
    }
  };

  useEffect(() => () => {
    resetLeagueTablePeriod();
  }, []);

  useEffect(() => {
    if (didMount.current) {
      getLeagueTablePeriods({ includedProductIds, includedRegionIds });
    } else {
      didMount.current = true;
    }
  }, [products, regions]);

  return (
    <TTMSelect
      value={ selectedPeriod }
      options={ periodsCollection }
      onChange={ onChange }
      isOptionDisabled={ (option) => option.disabled }
      dataTest="leagueTableTTMFilter"
    />
  );
};

export default LeagueTableTTMSelect;
